import cl from 'classnames'
import { isFieldRequired } from '@/utils'
import { Field } from '@/ui'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { getCurrentLanguage } from '@/i18next'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { handbookThunks } from '@/entity/handbook'
import { filterKato } from '@/entity/handbook/thunks'
import { useFormikContext, Field as FormikField } from 'formik'
import { Step1AdditionalAddressSchema } from '@features/regulatoryInformation/Modal.schema'

const FORM_NAME = {
	ddistrictCode: 'ddistrictCode',
	dregionCode: 'dregionCode',
	dlocalityCode: 'dlocalityCode',
	addressKz: 'addressKz',
	address: 'address',
}

export const AddAdditionalAddressForm = memo(({data}) => {
	const lang = getCurrentLanguage()
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const { values, setFieldValue, setFieldError, setFieldTouched, errors } = useFormikContext()

	const [regions, setRegions] = useState([])
	const [locality, setLocality] = useState([])

	const { countries, districts } = useSelector((state) => ({
		countries: state.handbook.countries,
		districts: state.handbook.districts,
	}))

	useEffect(() => {
		if (!countries?.length > 0) dispatch(handbookThunks.getCountries())
		if (!districts?.length > 0) dispatch(handbookThunks.getDistrictsAuth())


		if(data?.item?.ddistrictCode && data?.item?.dregionCode){
			if (values[FORM_NAME.ddistrictCode]) {
				handleGetRegion(values[FORM_NAME.ddistrictCode])
			}
			if (values[FORM_NAME.dregionCode]) {
				handleGetLocalty(values[FORM_NAME.dregionCode])
			}
		}
	}, [])

	const setDistrict = (code) => {
		setFieldValue(FORM_NAME.dregionCode, undefined)
		setFieldValue(FORM_NAME.dlocalityCode, undefined)
		handleGetRegion(code)
	}

	const setRegion = (code) => {
		handleGetLocalty(code)
	}

	const handleGetRegion = async (code) => {
		const res = await filterKato(code)
		setRegions(res)
	}

	const handleGetLocalty = async (value) => {
		let body = {
			data: {
				parentCode: value,
			},
			onSuccess: (res) => {
				setLocality(res.content)
				if (res.content?.length === 0) {
					setFieldValue(FORM_NAME.dlocalityCode, undefined)
				}
			},
			onError: () => {
			},
		}
		dispatch(handbookThunks.getDictKato(body))
	}

	return (
		<div>
			<div className={cl('flex', 'gap-3', 'mb-3')}>
				<div className={cl('flex-1')}>
					<FormikField name={FORM_NAME.ddistrictCode}>
						{({ field, meta: { touched, error } }) => {
							let isRequired = isFieldRequired(Step1AdditionalAddressSchema, FORM_NAME.ddistrictCode, values)
							return (
								<Field
									{...field}
									fieldType={'select'}
									options={districts}
									label={t('region')}
									placeholder={t('choose_from_directory')}
									onChange={(value) => {
										field.onChange(value)
										if (value) {
											setDistrict(value)
										}
									}}
									error={touched && error}
									isRequired={isRequired}
								/>
							)
						}}
					</FormikField>
				</div>

				<div className={cl('flex-1')}>
					<FormikField name={FORM_NAME.dregionCode}>
						{({ field, meta: { touched, error } }) => {
							let isRequired = isFieldRequired(Step1AdditionalAddressSchema, FORM_NAME.ddistrictCode, values)
							let disabled = !values.ddistrictCode

							return (
								<Field
									{...field}
									fieldType={'select'}
									options={regions}
									label={t('district')}
									placeholder={t('choose_from_directory')}
									onChange={(value) => {
										field.onChange(value)
										if (value) {
											setRegion(value)
										}
									}}
									disabled={disabled}
									error={touched && error}
									isRequired={isRequired}
								/>
							)
						}}
					</FormikField>
				</div>

				<div className={cl('flex-1')}>
					<FormikField name={FORM_NAME.dlocalityCode}>
						{({ field, meta: { touched, error } }) => {
							let isRequired = locality.length ? isFieldRequired(Step1AdditionalAddressSchema, FORM_NAME.ddistrictCode, values) : false
							let disabled = !values.dregionCode || !locality.length

							return (
								<Field
									{...field}
									fieldType={'select'}
									options={locality}
									label={t('populated_area')}
									placeholder={t('choose_from_directory')}
									disabled={disabled}
									error={touched && error}
									isRequired={isRequired}
								/>
							)
						}}
					</FormikField>
				</div>
			</div>

			<div className={cl('flex-1', 'mb-3')}>
				<FormikField name={FORM_NAME.addressKz}>
					{({ field, meta: { touched, error } }) => (
						<Field
							{...field}
							type="text"
							isRequired
							label={t('occupational_risks_assessment.steps.step_1.address_kaz')}
							placeholder={t('occupational_risks_assessment.steps.step_1.fact_address')}
							error={touched && error}
						/>
					)}
				</FormikField>
			</div>

			<div className={cl('flex-1', 'mb-3')}>
				<FormikField name={FORM_NAME.address}>
					{({ field, meta: { touched, error } }) => (
						<Field
							{...field}
							type="text"
							isRequired
							label={t('occupational_risks_assessment.steps.step_1.address_rus')}
							placeholder={t('occupational_risks_assessment.steps.step_1.fact_address')}
							error={touched && error}
						/>
					)}
				</FormikField>
			</div>

		</div>
	)
})